import { gql } from '@apollo/client';

const resendListedOfferEmail = gql`
  mutation ResendListedOfferEmail($offerId: String!) {
    sellDirect {
      resendListedOfferEmail(input: { offerId: $offerId }) {
        success
      }
    }
  }
`;

export default resendListedOfferEmail;
